<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Faturamento dos Clientes</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    v-if="pagination.TotalItems > 0"
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : '' "
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{labelName}}</th>
                    <th scope="col" class="border-0">{{labelIdentity}}</th>
                    <th scope="col" class="border-0">Valor faturado</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(profit, index) in profits" :key="index">
                    <td></td>
                    <td class="text-left">{{profit.Merchant.Name}}</td>
                    <td>{{profit.Merchant.Identity | identity}}</td>
                    <td>
                      <span class="badge badge-success">{{profit.NoteExtract.Amount | currency}}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="OpenProfit($event, index)"
                      >
                        <i class="fas fa-dollar-sign mr-1"></i> Faturamento
                      </button>
                    </td>
                  </tr>
                  <tr v-if="profits == undefined || profits == null || profits.length == 0">
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="4" class="form-group">
          <date-field v-model="filter.EmissionDate" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
        <d-col md="4" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "profits",
  components: {
    dateField
  },
  data: function() {
    return {
      countFilter: 1,
      filter: {
        EmissionDate: this.$options.filters.addMonth(new Date(), -1),
        Identity: null,
        Name: null,
      },
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      profits: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListProfit();
    },
    "pagination.RowsPerPage": function() {
      this.ListProfit();
    }
  },
  mounted() {
    this.ListProfit();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListProfit();
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        "Object.Merchant.Identity": this.filter.Identity,
        "Object.Merchant.Name": this.filter.Name,
        "Object.NoteExtract.EmissionDate": this.filter.EmissionDate
      }
      this.$store
        .dispatch("ReportProfitMerchant", { params: params })
        .then(response => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ListProfit: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.EmissionDate)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.Merchant.Name": this.filter.Name,
          "Object.NoteExtract.EmissionDate": this.filter.EmissionDate
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListProfitMerchant", { params: data })
        .then(response => {
          this.profits = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os clientes",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        EmissionDate: this.$options.filters.addMonth(new Date(), -1)
      };
      this.ListProfit();
    },
    OpenProfit: function(e, i) {
      e.preventDefault();
      let idMerchant = this.profits[i].Merchant.Id;
      this.$router.push({
        name: "profit",
        params: { idMerchant: idMerchant },
        query: {
          paymentDate: this.$options.filters.date(
            this.filter.EmissionDate,
            "YYYY-MM-DD"
          )
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/profits.vue